import React, { useState } from 'react';
import { fileUrl } from '../config/api';
export default function PanelAvatar({
  name,
  url,
  className,
  initials = 1
}: {
  name: string;
  url: string | null;
  className: string;
  initials?: number;
}) {
  const [failed, setFailed] = useState<string | null>(null);
  const letters = initials === 1 ? name.slice(0, 1) : name.split(' ').map(part => part.charAt(0)).slice(0, initials).join('');
  return <span className={className} aria-hidden="true">
    {url && failed !== url ? <img alt="" src={fileUrl(url)} onError={() => setFailed(url)} className="h-full w-full object-cover rounded-[inherit]" /> : letters.toLocaleUpperCase('tr-TR')}
  </span>;
}
